class OTFResetStyle {

    selector = '';
    style    = '';

    constructor(selector) {
        this.selector = selector;
    }

    reset() {
        let $selector = $(this.selector);
        this.style    = $selector.attr('style');
        $selector.attr('style', '');
    }

    revert(){
        if(this.style){
            $(this.selector).attr('style', this.style);
        }
    }
}